angular.module('bmsApp.merrymaids.schedule').
	controller('MMScheduleRouteNoteModalCtrl', MMScheduleRouteNoteModalCtrl)

MMScheduleRouteNoteModalCtrl.$inject = [
	'$scope',
	'$modalInstance',
	'$window',
	'$ngBootbox',
	'route',
]

function MMScheduleRouteNoteModalCtrl (
	$scope,
	$modalInstance,
	$window,
	$ngBootbox,
	route
) {
	let self = this;
	let methods = {};

	angular.extend(self, {
		methods: methods,
		note: route.note,
	});

	methods.save = () => {
		$modalInstance.close({
			note: self.note,
		});
	}

	methods.cancel = () => {
		if (self.note === route.note) {
			$modalInstance.dismiss('cancel');
		} else {
			$ngBootbox.confirm('Are you sure you want to close, changes to the note will be lost?')
			.then(function () {
				$modalInstance.dismiss('cancel');
			});
		}
	}
}